"use client";
import { TabsTrigger } from "@/components/ui/tabs";
import { useState, useRef, useEffect } from "react";
import { Separator } from "@/components/ui/separator";
import { motion } from "framer-motion";
import {
  CustomTabsTriggersType,
  QuranMushaf,
  TabTriggerListType,
} from "@/lib/types";
import { cn } from "@/lib/helpers/utils";
import { setCookie } from "@/lib/helpers/functions";
import { useTheme } from "@/app/providers/QuranThemeProvider";
import {
  useQuran,
  useQuranOptions,
  useQuranStateUpdate,
} from "@/app/providers/QuranContextProvider";

export function CustomTabsTriggers({
  tabList,
  showText = true,
  separator,
  separatorAt,
  tabIndicatorId,
  className,
}: CustomTabsTriggersType) {
  const [active, setActive] = useState<number>(tabList[0].id);
  const { colorMode, setColorMode } = useTheme();
  const { quranMushaf, quranFont } = useQuranOptions();
  const { setQuranFont, setQuranMushaf } = useQuranStateUpdate();

  let handleClick = (id: number, name: string) => {
    if (tabIndicatorId == "color-mode-indicator") {
      setCookie("color-mode", name, 365);
      setColorMode(name);
    }

    if (
      name.toLowerCase() == "indo-pak" ||
      name.toLowerCase() == "tajweed" ||
      name.toLowerCase() == "uthmani"
    )
      handleMushafChange(name, colorMode);

    setActive(id);
  };
  const handleMushafChange = (tabName: string, colorMode: string) => {
    let mushaf: QuranMushaf = { type: "hafs1", lines: 15 };

    if (tabName) {
      if (quranMushaf.type == tabName) return;
    }

    switch (tabName) {
      case "Indo-Pak":
        mushaf = { type: "indopak15", lines: 15 };
        setQuranFont("indo-pak");
        break;
      case "Tajweed":
        mushaf = { type: "hafs2", lines: 15 };
        setQuranFont("tajweed-" + colorMode);
        break;
      default:
        mushaf = { type: "hafs1", lines: 15 };
        setQuranFont("hafs1");
    }
    setQuranMushaf({ ...mushaf });
  };

  return (
    <>
      {tabList.map((t, index) => {
        let isActive = active == t.id;

        if (tabIndicatorId == "color-mode-indicator")
          isActive = t.name == colorMode;

        if (tabIndicatorId == "indicator-quran-fonts") {
          isActive = false;
          switch (quranMushaf.type) {
            case "hafs1":
              isActive = t.name == "Uthmani";
              break;
            case "hafs2":
              if (t.name == "Tajweed" && quranFont.includes("tajweed-")) {
                isActive = true;
              }

              if (
                t.name === "Uthmani" &&
                (quranFont == "hafs2" || quranFont == "uhfs")
              ) {
                isActive = true;
              }
              break;
            case "indopak15":
            case "indopak16":
              isActive = t.name == "Indo-Pak";
          }
        }

        return (
          <div
            className="w-full flex justify-center"
            key={tabIndicatorId + t.id}
          >
            <TabsTrigger
              // ref={(el) => setTabPosition(isActive, el)}
              value={t.name}
              className="h-[2rem] flex justify-center"
              onClick={() => handleClick(t.id, t.name)}
            >
              <div
                className={cn(
                  "w-full flex justify-center",
                  isActive ? " text-primary-foreground" : "",
                )}
                onClick={() => handleClick(t.id, t.name)}
              >
                <IconWrapper
                  key={t.name + t.id}
                  icon={t.icon}
                  id={t.id}
                  name={t.name}
                />
                {showText && (
                  <div
                    key={"div" + t.id}
                    className="pl-2 z-10 font-regular w-full"
                  >
                    {t.name.charAt(0).toUpperCase() + t.name.slice(1)}
                  </div>
                )}
              </div>
            </TabsTrigger>
            {/* {separator && t.id == separatorAt && (
              <Separator
                key={"sep" + t.id}
                orientation="vertical"
                className="bg-primary/40 h-3/4 mt-[3px]"
              />
            )} */}
          </div>
        );
      })}
    </>
  );
}

const IconWrapper = ({ icon, id, name }: TabTriggerListType) => {
  return <div className="flex flex-col justify-center">{icon}</div>;
};
